// import React from "react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function Web3Development() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const splitTextToSpans = (text, className = "") =>
        [...text].map((char, index) => (
            <span className={`char ${className}`} key={`${char}-${index}`}>
                {char === " " ? "\u00A0" : char}
            </span>
        ));

    // light dark change image

    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const currentTheme =
            document.documentElement.getAttribute("data-theme") || "light";
        setTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const newTheme =
                document.documentElement.getAttribute("data-theme") || "light";
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });

        return () => observer.disconnect();
    }, []);

    const journeyData = [
        {
            image: "assets/images/w3development/jour1.webp",
            text: "We work hands-on with you to comprehend your needs and contextualize Web3 for your business. We do so while exploring the benefits and challenges and co-innovating around the use case.",
        },
        {
            image: "assets/images/w3development/jour2.webp",
            text: "We help you prepare for the market disruption as a result of the successful Web 3.0 launch. Our strategy and advisory services help you gauge organizational readiness, anticipate the business impact, and devise a go-to-market plan.",
        },
        {
            image: "assets/images/w3development/jour3.webp",
            text: "We design and architect a Web 3.0 platform leveraging our rich domain knowledge and breadth of expertise. We work across the organization to engage stakeholders in legal and compliance businesses to build solutions ready for deployment.",
        },
        {
            image: "assets/images/w3development/jour4.webp",
            text: "We implement a Web 3.0 solution and authorize updates and changes. We constantly deliver our Web3 development services and support even after product deployment to ensure that our solutions have a tangible impact on your businesses.",
        },
    ];

    return (
        <>
            <Helmet>
                <title>Web3 Development Services | Decentralized Solutions | Blockcryp</title>
                <meta
                    name="description"
                    content="Build next-gen decentralized apps with Blockcryp’s Web3 development services. We deliver dApps, wallets, smart contracts, and DeFi solutions across blockchains."
                />
                <meta
                    name="keywords"
                    content="Web3 development services, Web3 development company, decentralized application development, dApp development company, smart contract development, DeFi Web3 solutions, blockchain app developers, Web3 wallet integration, Ethereum and Solana Web3 apps, custom Web3 development solutions"
                />
            </Helmet>
            {/* ---------- hreo section start ---------- */}
            <section className="space80">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 oreder-lg-1 order-2">
                            <motion.h1
                                className="heading_h1 fw-semibold"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            > <span className="text-primary fw-bold"> Web 3.0 </span> Development Services</motion.h1>
                            <motion.p
                                className="pera_txt"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Blockcryp offers expert <b> Web3 Development Services, </b> delivering interactive and future-ready solutions powered by blockchain, AI, IoT, and cryptography. As a leading <b> Web3 Development Company, </b> we provide services across various sectors including gaming, real estate, and fintech. Our skilled developers are proficient in Web3 tools, frameworks, APIs, oracles, and programming languages like Rust and Solidity.</motion.p>
                            <motion.button
                                className="button theme_btn px-3 mt-4 mt-lg-0" type="submit"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Contact Us</motion.button>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/w3development/web3hero3.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/w3development/web3hero.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Web 3 Solutions section start ---------- */}
            <section className="space80 services">
                <div className="container">
                    <div className="row justify-content-center g-4">
                        <div className="col-12 mt-0 mb-3">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center mb-3"
                            >
                                <>
                                    {splitTextToSpans(" Empowering Businesses with Top-Notch ")} <br className="d-md-block d-none" />
                                    {splitTextToSpans("Web 3.0 Solutions", "text-primary")}
                                </>
                            </ScrollFloat>
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Our web 3.0 solutions are focused on providing greater transparency, enhanced efficiency, ownership of data, and democratization. We help businesses by providing futuristic web 3.0 development solutions to enable them to stay ahead of the curve in this highly competitive market. The following means lead businesses to the path of success.</motion.p>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/solutions_icon1-dark.svg"
                                            : "assets/images/w3development/solutions_icon1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold">Decentralization</h5>
                                <p>Decentralization happens to be one of the most vital aspects of web 3.0. It is a distributed network that puts an end to the involvement of any centralized authority controlling the internet. Users are solely responsible for their data and content.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/solutions_icon2-dark.svg"
                                            : "assets/images/w3development/solutions_icon2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold">Blockchain Technology</h5>
                                <p>The introduction of blockchain plays a significant role in enabling transparent, tamper-proof, as well as secure transactions. It can bring about a massive transformation in the way online transactions are carried out by making them more secure.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/solutions_icon3-dark.svg"
                                            : "assets/images/w3development/solutions_icon3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Augmented Security and Privacy</h5>
                                <p className="mb-0">
                                    Decentralization makes provision for enhanced security since there is no single point of attack.
                                    In addition to this, users are provided with the power to select who can access their data and how.
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Web3 Development Services section start ---------- */}
            <section className="space60">
                <div className="container">
                    {/* <h2 className="heading_h3 fw-bold text-center mb-xl-2 mb-5">Our Comprehensive Range of <span className="text-primary">Web3 Development Services</span></h2> */}
                    <div className="row align-items-center g-4">
                        <div className="col-12">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center mb-3"
                            >
                                <>
                                    {splitTextToSpans(" Our Comprehensive Range of Web3")} <br className="d-md-block d-none" />
                                    {splitTextToSpans(" Development Services", "text-primary")}
                                </>
                            </ScrollFloat>
                        </div>
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-semibold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Web3 Smart Contract Development</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Secure Code Protocols :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Smart contracts are written with high-end security protocols to avoid vulnerabilities and ensure trustless within decentralized platforms.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Multi-Chain Support :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    BNB Chain and more, offering flexible deployment across networks via expert <b> Web3 Development Services </b> for seamless integration.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Audit-Ready Scripts :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Deliver audit-compliant code to meet safety standards and increase investor confidence before mainnet deployment in DeFi and NFTs.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/w3development/w33deve11.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/w3development/w33deve1.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- dApps Development section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/w3development/w33deve22.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/w3development/w33deve2.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold mb-4"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Web3 Custom dApps Development</motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >UI/UX Tailored Design :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Develop dApps with sleek interfaces and intuitive workflows that prioritize performance and accessibility for global Web3 users.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Backend Blockchain Logic :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Our <b> Web3 Development Company </b> ensures robust blockchain logic and oracle integrations for real-time data handling.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Cross-Platform Access :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Ensure your dApp works on web, mobile, and desktop environments—designed to deliver scalability, compatibility, and user satisfaction.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Native Payment Solutions section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-semibold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Web3 Native Payment Solutions
                            </motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Gas-Free Transactions :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Enable micro-payments and high-volume transactions with minimal fees using fast and efficient <b> Layer 2 Solutions </b> like Optimism.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Multi-Crypto Gateway :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Support various cryptocurrencies for seamless merchant or in-app payments, giving users flexible and secure transaction options.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Real-Time Settlements :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Integrate real-time blockchain settlement systems to enhance user trust and accelerate financial activities in decentralized ecosystems.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/w3development/w33deve33.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/w3development/w33deve3.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Metaverse Development section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/w3development/w33deve44.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/w3development/w33deve4.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold mb-4"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Web3 Metaverse Development
                                </motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Immersive 3D Environments :
                                </motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Build rich virtual worlds with avatars, land, and assets through cutting-edge <b> Web3 Metaverse Development </b> tools and frameworks.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >NFT-Based Assets :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Tokenize virtual goods, avatars, and property using NFTs to give users real ownership and tradability in the metaverse economy.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Social & DAO Features :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Enable community-driven governance and interaction features like chats, events, and DAOs to enrich the digital social experience.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Gaming Development section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <motion.h3
                                className="heading_h3 fw-semibold mb-4"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Web3 Gaming Development</motion.h3>
                            <div>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Play-to-Earn Models :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Integrate token rewards to incentivize gameplay, helping developers boost retention and offer real value to dedicated players.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >NFT Game Assets :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Develop tradable in-game NFTs such as characters, weapons, and skins with true ownership and marketplace interoperability.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-semibold mb-1"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Cross-Chain Gameplay :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Allow users to interact across blockchains using interoperable smart contracts to expand reach and player engagement.
                                </motion.p>
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-2 order-1">
                            <motion.div
                                initial={{ opacity: 0, x: 50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/w3development/w33deve55.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/w3development/w33deve5.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Self-Sovereign Identity section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-6">
                            <motion.div
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <ImageWithSkeleton
                                    src="assets/images/w3development/w33deve66.webp"
                                    alt=""
                                    className="w-100"
                                />
                                {/* <img src="assets/images/w3development/w33deve6.webp" alt="" className="w-100" /> */}
                            </motion.div>
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <motion.h3
                                    className="heading_h3 fw-bold mb-4"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Web3 Self-Sovereign Identity</motion.h3>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Decentralized Auth :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Eliminate third-party login systems and empower users with full control over their digital identity and verification processes.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Privacy-Preserving Tech :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Use zero-knowledge proofs and encryption to protect user data while ensuring secure and verifiable identity systems.
                                </motion.p>
                                <motion.h5
                                    className="heading_h5 fw-bold mb-1"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >Interoperable Wallet IDs :</motion.h5>
                                <motion.p
                                    className="para_text p-2"
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1, delay: 0.5 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    Enable one digital ID across dApps, wallets, and platforms for a smooth, Web3-native user experience.
                                </motion.p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- Web3 Development Journey Roof section start ---------- */}
            <section className="space60">
                <div className="container">
                    <div className="row">
                        <div className="col-12 p-0 mb-4">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center mb-lg-3"
                            >
                                <>
                                    {splitTextToSpans(" How do we Navigate your Web3")} <br className="d-md-block d-none" />
                                    {splitTextToSpans(" Development Journey", "text-primary")}
                                </>
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center"> <span className="text-primary fw-bold">  </span></h2> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >We follow a coherent roadmap to seamlessly drive your Web3 development process.
                            </motion.p>
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="col-xl-3 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <div className="d-flex justify-content-center">
                                    <img src="assets/images/w3development/jour1.webp" alt="" className="w-100" />
                                </div>
                                <p className="text-center">We work hands-on with you to comprehend your needs and contextualize Web3 for your business. We do so while exploring the benefits and challenges and co-innovating around the use case.</p>
                            </motion.div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <div className="d-flex justify-content-center">
                                    <img src="assets/images/w3development/jour2.webp" alt="" className="w-100" />
                                </div>
                                <p className="text-center">We help you prepare for the market disruption as a result of the successful Web 3.0 launch. Our strategy and advisory services help you gauge organizational readiness, anticipate the business impact, and devise a go-to-market plan.</p>
                            </motion.div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <div className="d-flex justify-content-center">
                                    <img src="assets/images/w3development/jour3.webp" alt="" className="w-100" />
                                </div>
                                <p className="text-center">We design and architect a Web 3.0 platform leveraging our rich domain knowledge and breadth of expertise. We work across the organization to engage stakeholders in legal and compliance businesses to build solutions ready for deployment.</p>
                            </motion.div>
                        </div>
                        <div className="col-xl-3 col-md-6">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <div className="d-flex justify-content-center">
                                    <img src="assets/images/w3development/jour4.webp" alt="" className="w-100" />
                                </div>
                                <p className="text-center">We implement a Web 3.0 solution and authorize updates and changes. We constantly deliver our Web3 development services and support even after product deployment to ensure that our solutions have a tangible impact on your businesses.</p>
                            </motion.div>
                        </div>
                    </div> */}
                    <div
                        className="row flex-nowrap"
                        style={{
                            overflowX: "auto",
                            overflowY: "hidden",
                            paddingBottom: "1rem",
                            scrollSnapType: "x mandatory",
                            WebkitOverflowScrolling: "touch",
                        }}
                    >
                        {journeyData.map((item, index) => (
                            <div
                                className="col-xl-3 col-md-6"
                                key={index}
                                style={{
                                    flex: "0 0 auto",
                                    maxWidth: "100%",
                                    scrollSnapAlign: "start",
                                }}
                            >
                                <motion.div
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 1, delay: 0.3 }}
                                    viewport={{ once: false, amount: 0.5 }}
                                >
                                    <div className="d-flex justify-content-center mb-3">
                                        <img src={item.image} alt={`journey-${index}`} className="w-100" />
                                    </div>
                                    <p className="text-center px-2">{item.text}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
            {/* ---------- Under One Roof section start ---------- */}
            <section className="space80 services">
                <div className="container">
                    <div className="row justify-content-center g-4">
                        <div className="col-12 mt-0 mb-3">
                            <ScrollFloat
                                animationDuration={1}
                                ease="back.inOut(2)"
                                scrollStart="center bottom+=50%"
                                scrollEnd="bottom bottom-=40%"
                                stagger={0.09}
                                textClassName="heading_h3 fw-semibold text-center"
                            >
                                Complete Package of Web 3.0 Development <br className="d-md-block d-none" /> Services Under One Roof
                            </ScrollFloat>
                            {/* <h2 className="heading_h3 fw-semibold text-center">Complete Package of Web 3.0 Development Services Under One Roof</h2> */}
                            <motion.p
                                className="text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >Check out web 3.0 development offerings and choose the one that best fits your business requirements.</motion.p>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/roof1-dark.svg"
                                            : "assets/images/w3development/roof1-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold">Web 3 Metaverse Development</h5>
                                <p>Our Web 3 metaverse development services are geared towards creating immersive metaverse platforms for diverse industries - such as Gaming, Entertainment, Real Estate, Fashion, Social Media, and more.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/roof2-dark.svg"
                                            : "assets/images/w3development/roof2-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold">Web 3 Wallet Development</h5>
                                <p>Whether you need a multichain web3 wallet or a blockchain-specific wallet, we offer customized web3 wallet development services to provide you with a secure web3 crypto wallet in line with your business needs.</p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/roof3-dark.svg"
                                            : "assets/images/w3development/roof3-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Web 3 Exchange Development</h5>
                                <p className="mb-0">
                                    Our business-oriented web 3.0 decentralized exchange development services empower businesses to disrupt the crypto market with a powerful exchange fortified with world-class performance and security.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/roof4-dark.svg"
                                            : "assets/images/w3development/roof4-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Web 3 Metaverse Game Development</h5>
                                <p className="mb-0">
                                    We provide end-to-end web 3 metaverse game development services to create NFTs and immersive gaming platforms for an exhilarating experience. Leverage our experience to build your metaverse game on web 3.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/roof5-dark.svg"
                                            : "assets/images/w3development/roof5-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Web3 Smart Contract Development</h5>
                                <p className="mb-0">
                                    Our web3 smart contract developer specializes in creating highly secure smart contracts to fortify decentralized applications. Capitalize on our web3 smart contract development services to tap into the DeFi world.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/roof6-dark.svg"
                                            : "assets/images/w3development/roof6-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Web 3.0 Browsers</h5>
                                <p className="mb-0">
                                    Our team of Web 3.0 developer harnesses the potential of blockchain technology to build highly secure applications and web 3.0-powered browsers that hold user data while keeping their identity anonymous.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/roof7-dark.svg"
                                            : "assets/images/w3development/roof7-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Web Streaming Services</h5>
                                <p className="mb-0">
                                    We leverage blockchain and smart contracts to create web streaming services that enable content creators to work transparently and get paid for their content.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/roof8-dark.svg"
                                            : "assets/images/w3development/roof8-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Decentralized Autonomous Organization (DAO)</h5>
                                <p className="mb-0">
                                    Our Web 3.0 developers build and deliver smart-contract-powered DAO platforms for different business use-cases.
                                </p>
                            </motion.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <motion.div
                                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.5 }}
                                viewport={{ once: false, amount: 0.5 }}
                            >
                                <img
                                    src={
                                        theme === "dark"
                                            ? "assets/images/w3development/roof9-dark.svg"
                                            : "assets/images/w3development/roof9-light.svg"
                                    }
                                    alt="Logo"
                                    className="mb-4"
                                />
                                <h5 className="heading_h5 fw-semibold mb-2">Decentralized Finance (DeFi)</h5>
                                <p className="mb-0">
                                    As a leading Web 3.0 development company, we build a range of DeFi platforms - including borrowing/lending, staking, yield farming, and more.
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ---------- faq section start ---------- */}
            <section className="space40">
                <div className="container">
                    <h2 className="heading_h3 fw-bold mb-4">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-12">
                            <div className="accordion">
                                <div className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(0)}>
                                        <span className="text_20 pe-4">
                                            1. What are Web 3.0 tools?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Web 3.0 tools enable decentralized apps (dApps) and services. Key tools include blockchain platforms (Ethereum, Polkadot), smart contract languages (Solidity, Rust), dev frameworks (Truffle, Hardhat), wallets (MetaMask), decentralized storage (IPFS), oracles (Chainlink), and DAO tools (Aragon).
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(1)}>
                                        <span className="text_20 pe-4">
                                            2. Is Web 3.0 the future of the Internet?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Web 3.0 is seen as the future of the Internet, focusing on decentralization, user control, and blockchain technology. It shifts power from centralized entities to individuals, enabling more secure, private, and transparent digital interactions.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(2)}>
                                        <span className="text_20 pe-4">
                                            3. How can Web3 benefit my business?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Adopting Web3 can provide your business with enhanced security, greater transparency, decentralized control, improved data privacy, and new revenue opportunities through blockchain technology.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0" onClick={() => toggleItem(3)}>
                                        <span className="text_20 pe-4">
                                            4. How does Blockcryp ensure Web3 security?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Blockcryp addresses security concerns in Web 3 development by implementing rigorous smart contract audits, employing best practices in cryptographic security, conducting regular security assessments, and using secure coding standards to prevent vulnerabilities.
                                        </p>
                                    </div>
                                </div>
                                <div className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""}`}>
                                    <button className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 " onClick={() => toggleItem(4)}>
                                        <span className="text_20 pe-4">
                                            5. What real-life use cases has Blockcryp worked on?
                                        </span>
                                        <span className="accordion__icon">
                                            <i className="fa fa-plus" />
                                        </span>
                                    </button>
                                    <div className="accordion__content">
                                        <p className="p-2">
                                            Blockcryp has tackled real-life use cases including DeFi platforms for secure trading, blockchain solutions for transparent supply chains, decentralized healthcare data management, blockchain-based in-game asset ownership, and tokenized real estate transactions for added security and transparency.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
